import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import axios from "axios";
import AdminNav from "./AdminNav";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { Modal } from "antd";
const WithdrawDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [withdraw, setWithdraw] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");
  useEffect(() => {
    const fetchWithdrawData = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/withdraw/get-withdraw/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success);
        setWithdraw(data.withdrawRequest);
      } catch (error) {
        console.error(error);
      }
    };
    fetchWithdrawData();
  }, [id, token]);

  const handleRejectModal = () => setIsRejectModalVisible(true);
  const handleApproveSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/api/v1/withdraw/approve/${id}`,
        {
          status: "approved",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 200 && res.data.success) {
        // Success
        toast.success(res.data.message);
        navigate("/dashboard/admin/withdrawals");
      } else {
        // Handle unexpected response with a general error
        toast.error(
          res.data.message || "Something went wrong. Please try again."
        );
      }
    } catch (error) {
      // Specific error handling
      if (error.response) {
        // Server responded with a status other than 200 range
        const { status, data } = error.response;

        if (status === 400) {
          toast.error(
            data.message || "Bad Request. Please check the input and try again."
          );
        } else if (status === 404) {
          toast.error(data.message || "Withdrawal Request not found.");
        } else if (status === 500) {
          toast.error(data.message || "Server error. Please try again later.");
        } else {
          toast.error(data.message || `Unexpected error: ${status}`);
        }
      } else if (error.request) {
        // No response received
        toast.error("No response from server. Please check your connection.");
      } else {
        // Other errors
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const submitRejection = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/api/v1/withdraw/reject/${id}`,
        {
          rejectReason,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.data.success) {
        toast.success("Withdrawal Request Rejected Successfully");
        navigate("/dashboard/admin/withdrawals");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to reject withdrawal request. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="wrapper d-flex align-items-stretch">
        {loading && <Loader />}
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2 pt-3">
          <button type="button" onClick={toggleSidebar} className="bars-btn">
            <FaBarsStaggered />
          </button>
          <AdminNav />

          <div className="shadow-lg rounded-3 p-4 deposit-card">
            <h4 className="mb-3 text-uppercase">Withdrawal request Details </h4>

            <div className="border my-2 rounded-2 px-3 py-2">
              <label className="d-flex justify-content-between mb-2">
                <span>User Name :</span>
                <span>{withdraw?.userId?.name || "N/A"}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>User Email :</span>
                <span>{withdraw?.userId?.email || "N/A"}</span>
              </label>

              <label className="d-flex justify-content-between mb-2">
                <span>Account :</span>
                <span>{withdraw.account}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Fund Name:</span>
                <span>{withdraw?.fund?.name || "N/A"}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Fund Type:</span>
                <span>{withdraw?.fund?.type}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Class Name:</span>
                <span>{withdraw?.class?.class || "N/A"}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Redemption Fee:</span>
                <span>{withdraw?.class?.redemptionFee}</span>
              </label>

              <label className="d-flex justify-content-between mb-2">
                <span>Currency:</span>
                <span>{withdraw?.class?.currency}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Amount:</span>
                <span>{withdraw?.amount}</span>
              </label>
            </div>
            {withdraw.status === "pending" && (
              <div className="d-flex justify-content-end mt-3">
                <button
                  onClick={handleApproveSubmit}
                  className="text-success bg-transparent border-0 mx-3"
                >
                  APPROVE
                </button>
                <button
                  onClick={handleRejectModal}
                  className="text-danger bg-transparent border-0 mx-3"
                >
                  REJECT
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        open={isRejectModalVisible}
        footer={null}
        onCancel={() => setIsRejectModalVisible(false)}
      >
        <form>
          <h4 className="mb-4">Reject Withdrawal Request</h4>

          <div className="mb-1 d-flex flex-column">
            <label>Rejection Reason</label>
            <textarea
              className="wallet-address-input"
              rows={4}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              required
              placeholder="Reason for rejection"
            />{" "}
          </div>
          <div className="mt-3">
            <button
              type="button"
              onClick={submitRejection}
              className="btn btn-primary my-3"
            >
              Reject
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default WithdrawDetails;
